import styled from '@emotion/styled';
import {Button} from '@bosch/react-frok';

export const TabNavigationWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
    overflow-y: auto;
    min-height: 780px;
    min-width: 320px;
    max-height: 780px;
    max-width: 640px;

    .a-tab-navigation {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: start;
        border-color: transparent;
        border-bottom: 1px solid var(--bosch-gray-40);
    }

    .a-tab-navigation__wrapper {
        position: relative;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .a-tab-navigation__gradients {
        position: inherit;
    }
`;

export const TabNavigation = styled.ol`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
    max-height: 6rem;
    overflow-y: auto;
    list-style: none;
    margin: 0 0 0.5rem 0;
    padding: 0;
`;

export const TabButton = styled(Button)`
    padding: 0 1rem 0 0;
    min-width: 64px;
`;
